(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide-popup"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('amdt-size-guide')){
customElements.define('amdt-size-guide',class extends HTMLElement{
connectedCallback(){if(this.bound)return;this.bound=true;const dialog=this.querySelector('dialog');const trigger=this.querySelector('.amdt-size-trigger');trigger.addEventListener('click',()=>dialog.showModal());this.querySelector('.amdt-size-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});dialog.addEventListener('close',()=>trigger.focus());}
});}
  } catch(e) { console.error(e); }
})();

})();
